import React from "react";

import { useTranslation } from "utils";

import { Flex, Modal, Typography } from "components";

type UndersowingOverlapWarningModalProps = {
  dataTestId: string;
  cropNames: string[];
  // forwards the modal's own click event, since AddEditCropDrawer's onSubmit needs one — other callers can just
  // ignore the parameter
  onConfirm: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onCancel: () => void;
};

// shared by every drawer that can edit a Main crop's dates (single or bulk) — an edit can orphan an already-saved
// Undersowing crop's required overlap, which a save would otherwise silently miss since it only validates the
// crop being edited (see getUndersowingCropsInvalidatedByChange/getUndersowingWarningsForChanges in CropValidationUtils.ts)
export const UndersowingOverlapWarningModal = ({ dataTestId, cropNames, onConfirm, onCancel }: UndersowingOverlapWarningModalProps) => {
  const { t } = useTranslation("allFieldView");

  return (
    <Modal
      dataTestId={dataTestId}
      showModal={cropNames.length > 0}
      title={t("cropForm.undersowingOverlapWarningModal.title")}
      content={
        <Flex vertical gap="0.5rem">
          <Typography variant="paragraph-m" className="margin-0">
            {t("cropForm.undersowingOverlapWarningModal.descriptionIntro")}
          </Typography>
          <Typography variant="paragraph-m" bold className="margin-0">
            {cropNames.join(", ")}
          </Typography>
          <Typography variant="paragraph-m" className="margin-0">
            {t("cropForm.undersowingOverlapWarningModal.descriptionQuestion")}
          </Typography>
        </Flex>
      }
      okText={t("cropForm.undersowingOverlapWarningModal.confirm")}
      cancelText={t("cropForm.undersowingOverlapWarningModal.cancel")}
      onCancel={onCancel}
      onOk={(e) => onConfirm(e)}
    />
  );
};
